module.exports = __webpack_public_path__ + "static/media/cancel.cbb9f932.svg";